// AUTO-GENERATED & MANUALLY STRUCTURED ACTION TYPES

// ===== Auth =====
export const SET_AUTH = "SET_AUTH";
export const LOGOUT = "LOGOUT";

// ===== Projects =====
export const CREATE_PROJECT = "CREATE_PROJECT";
export const DELETE_PROJECT = "DELETE_PROJECT";
export const GET_ALL_PROJECTS = "GET_ALL_PROJECTS";
export const GET_ALL_PROJECTS_RESPONSE = "GET_ALL_PROJECTS_RESPONSE";
export const GET_PROJECT_BY_COMPANY_ID = "GET_PROJECT_BY_COMPANY_ID";
export const GET_PROJECT_BY_COMPANY_ID_RESPONSE = "GET_PROJECT_BY_COMPANY_ID_RESPONSE";
export const GET_PROJECT_BY_ID = "GET_PROJECT_BY_ID";
export const GET_PROJECT_BY_ID_RESPONSE = "GET_PROJECT_BY_ID_RESPONSE";
export const UPDATE_PROJECT = "UPDATE_PROJECT";
export const GET_SEARCH_DATA = "GET_SEARCH_DATA";
export const GET_SEARCH_DATA_RESPONSE = "GET_SEARCH_DATA_RESPONSE";
export const CLEAR_SEARCH_DATA = "CLEAR_SEARCH_DATA";

// ===== Roles =====
export const GET_ROLES_BY_COMPANY_ID = "GET_ROLES_BY_COMPANY_ID";
export const GET_ROLES_BY_COMPANY_ID_RESPONSE = "GET_ROLES_BY_COMPANY_ID_RESPONSE";

// ===== AuditLog =====
export const CREATE_AUDIT_LOG = "CREATE_AUDIT_LOG";
export const DELETE_AUDIT_LOG = "DELETE_AUDIT_LOG";
export const GET_ALL_AUDIT_LOGS = "GET_ALL_AUDIT_LOGS";
export const GET_ALL_AUDIT_LOGS_RESPONSE = "GET_ALL_AUDIT_LOGS_RESPONSE";
export const GET_AUDIT_LOG_BY_ID = "GET_AUDIT_LOG_BY_ID";
export const GET_AUDIT_LOG_BY_ID_RESPONSE = "GET_AUDIT_LOG_BY_ID_RESPONSE";
export const UPDATE_AUDIT_LOG = "UPDATE_AUDIT_LOG";

// ===== Brand =====
export const CREATE_BRAND = "CREATE_BRAND";
export const DELETE_BRAND = "DELETE_BRAND";
export const GET_ALL_BRANDS = "GET_ALL_BRANDS";
export const GET_ALL_BRANDS_RESPONSE = "GET_ALL_BRANDS_RESPONSE";
export const GET_BRAND_BY_ID = "GET_BRAND_BY_ID";
export const GET_BRAND_BY_ID_RESPONSE = "GET_BRAND_BY_ID_RESPONSE";
export const UPDATE_BRAND = "UPDATE_BRAND";

// ===== Company =====
export const CREATE_COMPANY = "CREATE_COMPANY";
export const DELETE_COMPANY = "DELETE_COMPANY";
export const GET_ALL_COMPANYS = "GET_ALL_COMPANYS";
export const GET_ALL_COMPANYS_RESPONSE = "GET_ALL_COMPANYS_RESPONSE";
export const GET_COMPANY_BY_ID = "GET_COMPANY_BY_ID";
export const GET_COMPANY_BY_ID_RESPONSE = "GET_COMPANY_BY_ID_RESPONSE";
export const UPDATE_COMPANY = "UPDATE_COMPANY";

// ===== Design =====
export const CREATE_DESIGN = "CREATE_DESIGN";
export const DELETE_DESIGN = "DELETE_DESIGN";
export const GET_ALL_DESIGNS = "GET_ALL_DESIGNS";
export const GET_ALL_DESIGNS_RESPONSE = "GET_ALL_DESIGNS_RESPONSE";
export const GET_DESIGN_BY_ID = "GET_DESIGN_BY_ID";
export const GET_DESIGN_BY_ID_RESPONSE = "GET_DESIGN_BY_ID_RESPONSE";
export const UPDATE_DESIGN = "UPDATE_DESIGN";

// ===== DesignVersion =====
export const CREATE_DESIGN_VERSION = "CREATE_DESIGN_VERSION";
export const DELETE_DESIGN_VERSION = "DELETE_DESIGN_VERSION";
export const GET_ALL_DESIGN_VERSIONS = "GET_ALL_DESIGN_VERSIONS";
export const GET_ALL_DESIGN_VERSIONS_RESPONSE = "GET_ALL_DESIGN_VERSIONS_RESPONSE";
export const GET_DESIGN_VERSION_BY_ID = "GET_DESIGN_VERSION_BY_ID";
export const GET_DESIGN_VERSION_BY_ID_RESPONSE = "GET_DESIGN_VERSION_BY_ID_RESPONSE";
export const UPDATE_DESIGN_VERSION = "UPDATE_DESIGN_VERSION";

// ===== Document =====
export const CREATE_DOCUMENT = "CREATE_DOCUMENT";
export const DELETE_DOCUMENT = "DELETE_DOCUMENT";
export const GET_ALL_DOCUMENTS = "GET_ALL_DOCUMENTS";
export const GET_ALL_DOCUMENTS_RESPONSE = "GET_ALL_DOCUMENTS_RESPONSE";
export const GET_DOCUMENT_BY_ID = "GET_DOCUMENT_BY_ID";
export const GET_DOCUMENT_BY_ID_RESPONSE = "GET_DOCUMENT_BY_ID_RESPONSE";
export const UPDATE_DOCUMENT = "UPDATE_DOCUMENT";

// ===== Engagement =====
export const CREATE_ENGAGEMENT = "CREATE_ENGAGEMENT";
export const DELETE_ENGAGEMENT = "DELETE_ENGAGEMENT";
export const GET_ALL_ENGAGEMENTS = "GET_ALL_ENGAGEMENTS";
export const GET_ALL_ENGAGEMENTS_RESPONSE = "GET_ALL_ENGAGEMENTS_RESPONSE";
export const GET_ENGAGEMENT_BY_ID = "GET_ENGAGEMENT_BY_ID";
export const GET_ENGAGEMENT_BY_ID_RESPONSE = "GET_ENGAGEMENT_BY_ID_RESPONSE";
export const UPDATE_ENGAGEMENT = "UPDATE_ENGAGEMENT";

// ===== FabricOption =====
export const CREATE_FABRIC_OPTION = "CREATE_FABRIC_OPTION";
export const DELETE_FABRIC_OPTION = "DELETE_FABRIC_OPTION";
export const GET_ALL_FABRIC_OPTIONS = "GET_ALL_FABRIC_OPTIONS";
export const GET_ALL_FABRIC_OPTIONS_RESPONSE = "GET_ALL_FABRIC_OPTIONS_RESPONSE";
export const GET_FABRIC_OPTION_BY_ID = "GET_FABRIC_OPTION_BY_ID";
export const GET_FABRIC_OPTION_BY_ID_RESPONSE = "GET_FABRIC_OPTION_BY_ID_RESPONSE";
export const UPDATE_FABRIC_OPTION = "UPDATE_FABRIC_OPTION";

// ===== LedgerEntry =====
export const CREATE_LEDGER_ENTRY = "CREATE_LEDGER_ENTRY";
export const DELETE_LEDGER_ENTRY = "DELETE_LEDGER_ENTRY";
export const GET_ALL_LEDGER_ENTRYS = "GET_ALL_LEDGER_ENTRYS";
export const GET_ALL_LEDGER_ENTRYS_RESPONSE = "GET_ALL_LEDGER_ENTRYS_RESPONSE";
export const GET_LEDGER_ENTRY_BY_ID = "GET_LEDGER_ENTRY_BY_ID";
export const GET_LEDGER_ENTRY_BY_ID_RESPONSE = "GET_LEDGER_ENTRY_BY_ID_RESPONSE";
export const UPDATE_LEDGER_ENTRY = "UPDATE_LEDGER_ENTRY";

// ===== Manufacturer =====
export const CREATE_MANUFACTURER = "CREATE_MANUFACTURER";
export const DELETE_MANUFACTURER = "DELETE_MANUFACTURER";
export const GET_ALL_MANUFACTURERS = "GET_ALL_MANUFACTURERS";
export const GET_ALL_MANUFACTURERS_RESPONSE = "GET_ALL_MANUFACTURERS_RESPONSE";
export const GET_MANUFACTURER_BY_ID = "GET_MANUFACTURER_BY_ID";
export const GET_MANUFACTURER_BY_ID_RESPONSE = "GET_MANUFACTURER_BY_ID_RESPONSE";
export const UPDATE_MANUFACTURER = "UPDATE_MANUFACTURER";

// ===== Notification =====
export const CREATE_NOTIFICATION = "CREATE_NOTIFICATION";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const GET_ALL_NOTIFICATIONS = "GET_ALL_NOTIFICATIONS";
export const GET_ALL_NOTIFICATIONS_RESPONSE = "GET_ALL_NOTIFICATIONS_RESPONSE";
export const GET_NOTIFICATION_BY_ID = "GET_NOTIFICATION_BY_ID";
export const GET_NOTIFICATION_BY_ID_RESPONSE = "GET_NOTIFICATION_BY_ID_RESPONSE";
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";

// ===== Order =====
export const CREATE_ORDER = "CREATE_ORDER";
export const DELETE_ORDER = "DELETE_ORDER";
export const GET_ALL_ORDERS = "GET_ALL_ORDERS";
export const GET_ALL_ORDERS_RESPONSE = "GET_ALL_ORDERS_RESPONSE";
export const GET_ORDER_BY_ID = "GET_ORDER_BY_ID";
export const GET_ORDER_BY_ID_RESPONSE = "GET_ORDER_BY_ID_RESPONSE";
export const UPDATE_ORDER = "UPDATE_ORDER";

// ===== OrderDispatch =====
export const CREATE_ORDER_DISPATCH = "CREATE_ORDER_DISPATCH";
export const DELETE_ORDER_DISPATCH = "DELETE_ORDER_DISPATCH";
export const GET_ALL_ORDER_DISPATCHS = "GET_ALL_ORDER_DISPATCHS";
export const GET_ALL_ORDER_DISPATCHS_RESPONSE = "GET_ALL_ORDER_DISPATCHS_RESPONSE";
export const GET_ORDER_DISPATCH_BY_ID = "GET_ORDER_DISPATCH_BY_ID";
export const GET_ORDER_DISPATCH_BY_ID_RESPONSE = "GET_ORDER_DISPATCH_BY_ID_RESPONSE";
export const UPDATE_ORDER_DISPATCH = "UPDATE_ORDER_DISPATCH";

// ===== OrderEstimate =====
export const CREATE_ORDER_ESTIMATE = "CREATE_ORDER_ESTIMATE";
export const DELETE_ORDER_ESTIMATE = "DELETE_ORDER_ESTIMATE";
export const GET_ALL_ORDER_ESTIMATES = "GET_ALL_ORDER_ESTIMATES";
export const GET_ALL_ORDER_ESTIMATES_RESPONSE = "GET_ALL_ORDER_ESTIMATES_RESPONSE";
export const GET_ORDER_ESTIMATE_BY_ID = "GET_ORDER_ESTIMATE_BY_ID";
export const GET_ORDER_ESTIMATE_BY_ID_RESPONSE = "GET_ORDER_ESTIMATE_BY_ID_RESPONSE";
export const UPDATE_ORDER_ESTIMATE = "UPDATE_ORDER_ESTIMATE";

// ===== OrderLineItem =====
export const CREATE_ORDER_LINE_ITEM = "CREATE_ORDER_LINE_ITEM";
export const DELETE_ORDER_LINE_ITEM = "DELETE_ORDER_LINE_ITEM";
export const GET_ALL_ORDER_LINE_ITEMS = "GET_ALL_ORDER_LINE_ITEMS";
export const GET_ALL_ORDER_LINE_ITEMS_RESPONSE = "GET_ALL_ORDER_LINE_ITEMS_RESPONSE";
export const GET_ORDER_LINE_ITEM_BY_ID = "GET_ORDER_LINE_ITEM_BY_ID";
export const GET_ORDER_LINE_ITEM_BY_ID_RESPONSE = "GET_ORDER_LINE_ITEM_BY_ID_RESPONSE";
export const UPDATE_ORDER_LINE_ITEM = "UPDATE_ORDER_LINE_ITEM";

// ===== OrderTimelineEvent =====
export const CREATE_ORDER_TIMELINE_EVENT = "CREATE_ORDER_TIMELINE_EVENT";
export const DELETE_ORDER_TIMELINE_EVENT = "DELETE_ORDER_TIMELINE_EVENT";
export const GET_ALL_ORDER_TIMELINE_EVENTS = "GET_ALL_ORDER_TIMELINE_EVENTS";
export const GET_ALL_ORDER_TIMELINE_EVENTS_RESPONSE = "GET_ALL_ORDER_TIMELINE_EVENTS_RESPONSE";
export const GET_ORDER_TIMELINE_EVENT_BY_ID = "GET_ORDER_TIMELINE_EVENT_BY_ID";
export const GET_ORDER_TIMELINE_EVENT_BY_ID_RESPONSE = "GET_ORDER_TIMELINE_EVENT_BY_ID_RESPONSE";
export const UPDATE_ORDER_TIMELINE_EVENT = "UPDATE_ORDER_TIMELINE_EVENT";

// ===== PaymentReceipt =====
export const CREATE_PAYMENT_RECEIPT = "CREATE_PAYMENT_RECEIPT";
export const DELETE_PAYMENT_RECEIPT = "DELETE_PAYMENT_RECEIPT";
export const GET_ALL_PAYMENT_RECEIPTS = "GET_ALL_PAYMENT_RECEIPTS";
export const GET_ALL_PAYMENT_RECEIPTS_RESPONSE = "GET_ALL_PAYMENT_RECEIPTS_RESPONSE";
export const GET_PAYMENT_RECEIPT_BY_ID = "GET_PAYMENT_RECEIPT_BY_ID";
export const GET_PAYMENT_RECEIPT_BY_ID_RESPONSE = "GET_PAYMENT_RECEIPT_BY_ID_RESPONSE";
export const UPDATE_PAYMENT_RECEIPT = "UPDATE_PAYMENT_RECEIPT";

// ===== Requirement =====
export const CREATE_REQUIREMENT = "CREATE_REQUIREMENT";
export const DELETE_REQUIREMENT = "DELETE_REQUIREMENT";
export const GET_ALL_REQUIREMENTS = "GET_ALL_REQUIREMENTS";
export const GET_ALL_REQUIREMENTS_RESPONSE = "GET_ALL_REQUIREMENTS_RESPONSE";
export const GET_REQUIREMENT_BY_ID = "GET_REQUIREMENT_BY_ID";
export const GET_REQUIREMENT_BY_ID_RESPONSE = "GET_REQUIREMENT_BY_ID_RESPONSE";
export const UPDATE_REQUIREMENT = "UPDATE_REQUIREMENT";

// ===== User =====
export const CREATE_USER = "CREATE_USER";
export const DELETE_USER = "DELETE_USER";
export const GET_ALL_USERS = "GET_ALL_USERS";
export const GET_ALL_USERS_RESPONSE = "GET_ALL_USERS_RESPONSE";
export const GET_USER_BY_ID = "GET_USER_BY_ID";
export const GET_USER_BY_ID_RESPONSE = "GET_USER_BY_ID_RESPONSE";
export const UPDATE_USER = "UPDATE_USER";

// ===== WorkflowTask =====
export const CREATE_WORKFLOW_TASK = "CREATE_WORKFLOW_TASK";
export const DELETE_WORKFLOW_TASK = "DELETE_WORKFLOW_TASK";
export const GET_ALL_WORKFLOW_TASKS = "GET_ALL_WORKFLOW_TASKS";
export const GET_ALL_WORKFLOW_TASKS_RESPONSE = "GET_ALL_WORKFLOW_TASKS_RESPONSE";
export const GET_WORKFLOW_TASK_BY_ID = "GET_WORKFLOW_TASK_BY_ID";
export const GET_WORKFLOW_TASK_BY_ID_RESPONSE = "GET_WORKFLOW_TASK_BY_ID_RESPONSE";
export const UPDATE_WORKFLOW_TASK = "UPDATE_WORKFLOW_TASK";

// ===== Optimistic list patching (shared by every entity reducer) =====
export const ENTITY_LIST_PATCH = "ENTITY_LIST_PATCH";

// ===== Profiles & Dashboards =====
export const GET_BRAND_PROFILE = "GET_BRAND_PROFILE";
export const GET_BRAND_PROFILE_RESPONSE = "GET_BRAND_PROFILE_RESPONSE";
export const GET_MANUFACTURER_PROFILE = "GET_MANUFACTURER_PROFILE";
export const GET_MANUFACTURER_PROFILE_RESPONSE = "GET_MANUFACTURER_PROFILE_RESPONSE";
export const GET_BRAND_DASHBOARD = "GET_BRAND_DASHBOARD";
export const GET_BRAND_DASHBOARD_RESPONSE = "GET_BRAND_DASHBOARD_RESPONSE";
export const GET_MANUFACTURER_DASHBOARD = "GET_MANUFACTURER_DASHBOARD";
export const GET_MANUFACTURER_DASHBOARD_RESPONSE = "GET_MANUFACTURER_DASHBOARD_RESPONSE";

// ===== Workflow actions =====
export const APPROVE_PAYMENT_RECEIPT = "APPROVE_PAYMENT_RECEIPT";
export const REJECT_PAYMENT_RECEIPT = "REJECT_PAYMENT_RECEIPT";
export const APPROVE_FABRIC_OPTION = "APPROVE_FABRIC_OPTION";
export const REJECT_FABRIC_OPTION = "REJECT_FABRIC_OPTION";
export const UPLOAD_DESIGN_VERSION = "UPLOAD_DESIGN_VERSION";
export const DISPATCH_ORDER = "DISPATCH_ORDER";
export const CONFIRM_ORDER_RECEIPT = "CONFIRM_ORDER_RECEIPT";
export const MOVE_WORKFLOW_TASK = "MOVE_WORKFLOW_TASK";
export const MARK_NOTIFICATION_READ = "MARK_NOTIFICATION_READ";
export const MARK_ALL_NOTIFICATIONS_READ = "MARK_ALL_NOTIFICATIONS_READ";
export const GET_UNREAD_NOTIFICATION_COUNT = "GET_UNREAD_NOTIFICATION_COUNT";
export const GET_UNREAD_NOTIFICATION_COUNT_RESPONSE = "GET_UNREAD_NOTIFICATION_COUNT_RESPONSE";
export const INVITE_USER = "INVITE_USER";
export const UPDATE_USER_STATUS = "UPDATE_USER_STATUS";

// ===== Reports =====
export const GET_ALL_REPORTS = "GET_ALL_REPORTS";
export const GET_ALL_REPORTS_RESPONSE = "GET_ALL_REPORTS_RESPONSE";
export const CREATE_REPORT = "CREATE_REPORT";
export const EXPORT_REPORT = "EXPORT_REPORT";
export const DELETE_REPORT = "DELETE_REPORT";

// ===== Comments =====
export const GET_ALL_COMMENTS = "GET_ALL_COMMENTS";
export const GET_ALL_COMMENTS_RESPONSE = "GET_ALL_COMMENTS_RESPONSE";
export const CREATE_COMMENT = "CREATE_COMMENT";
export const DELETE_COMMENT = "DELETE_COMMENT";

// ===== DebitCategory =====
export const CREATE_DEBIT_CATEGORY = "CREATE_DEBIT_CATEGORY";
export const DELETE_DEBIT_CATEGORY = "DELETE_DEBIT_CATEGORY";
export const GET_ALL_DEBIT_CATEGORIES = "GET_ALL_DEBIT_CATEGORIES";
export const GET_ALL_DEBIT_CATEGORIES_RESPONSE = "GET_ALL_DEBIT_CATEGORIES_RESPONSE";
export const GET_DEBIT_CATEGORY_BY_ID = "GET_DEBIT_CATEGORY_BY_ID";
export const GET_DEBIT_CATEGORY_BY_ID_RESPONSE = "GET_DEBIT_CATEGORY_BY_ID_RESPONSE";
export const UPDATE_DEBIT_CATEGORY = "UPDATE_DEBIT_CATEGORY";
export const UPDATE_MANUFACTURER_PROFILE = "UPDATE_MANUFACTURER_PROFILE";
